import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Observable, throwError } from 'rxjs';
import { Todos } from '../models/todos';
import { Users } from '../models/users';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  URLbase: string = "https://jsonplaceholder.typicode.com/";
  toDos: string = "todos/";
  user: string = "users/"

  constructor(private http: HttpClient) { }

  public getItems(extension: string): Observable<any> {

    return this.http.get(this.URLbase + extension)
    .pipe(
      catchError(this.handleError)
    );
  }

  public getList(id: string): Observable<any>{
    console.log(this.URLbase + this.user + id + '/' + this.toDos)
    return this.http.get(this.URLbase + this.user + id + '/' + this.toDos)
    .pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse){
    if (error.status === 0) {
      // Ocurrió un error del lado del cliente. Manejarlo de acuerdo 
      console.error('Un error ha ocurrido', error.error);
    } else {
      // El backend retornó un codigo de respuesta no exitoso
      // El cuerpo del response puede contener pistas de lo que puede estar malo.
      console.error(
        `El backend retornó un código ${error.status}, ` +
        `el body fue: ${error.error}`
      );
    }
    // Retorna un observable con un mensaje para el usuario
    return throwError(
      'Algo ha salido mal'
    );
  }

}
